import React, {
  useEffect,
  useRef,
  useState
} from 'react';
import { Box, useMediaQuery, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Footer from '../components/Footer.jsx';
import FAQ from '../components/FAQ';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../AppContext';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../routes/routeConstants';
import { useNBCUSDK } from "../context/sdk/useSDK.js";
import { useDevHub } from '../context/devhub/useDevHubSDK.js';
import './Home.css';

const question = require('../assets/question_2x.png');
const epic_logo = require('../assets/UEU-Logo-Drop-Shadow_optimized 1.png');

const HomePage = () => {
  const navigate = useNavigate();

  const [isLoading] = useState(false);

  const { userProfile } = useAppContext();
  const { devHubUser } = useDevHub();

  // Get SDK context
  const { handleOAuthLogin } = useNBCUSDK();

  // Create a ref for the FAQ section
  const targetRef = useRef(null);

  // Get the current location state
  const location = useLocation();
  const state = location.state || {};

  // Scroll to FAQ section only if the state indicates the link was clicked
  useEffect(() => {
    if (state.scrollToTarget) {
      setTimeout(() => {
        const element = document.getElementById(state.scrollToTarget);
        element && element.scrollIntoView({ behavior: 'smooth' });
      }, 1000)
    }
  }, [location, state.scrollToTarget, navigate]);

  useEffect(() => {
    if (!userProfile.userId) {
       navigate(ROUTES.ROOT);
    }
  }, [userProfile, navigate]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <div id="home-page">
      <div className="background">
        <img 
          src={epic_logo} 
          alt="Universal Epic Universe logo" 
          style={{
            display: 'block',
            margin: '0 auto',
            width: '100%',
            maxWidth: 270
          }} 
        />
        <h2 style={{
          color: '#fff',
          fontWeight: 600,
          textAlign: 'center',
          lineHeight: '48px',
          fontSize: '20px',
          maxWidth: 780,
          display: 'block',
          margin: '-20px auto 0 auto',
          letterSpacing: 2
        }}>
          UNIVERSAL EPIC UNIVERSE
        </h2>
        <h2 style={{
          color: '#fff',
          fontWeight: 600,
          textAlign: 'center',
          lineHeight: '48px',
          fontSize: isSmallScreen ? '36px' : '38px',
          maxWidth: 780,
          display: 'block',
          margin: '0 auto',
          padding: '0 10px',
          letterSpacing: 0
        }}>
          Grand Opening Day Digital Medallion
        </h2>
        <img 
          src={question} 
          alt="Mystery medallion" 
          width={isSmallScreen ? 140 : 200} 
          style={{
            display: 'block',
            margin: isSmallScreen ? '25px auto 15px auto' : '45px auto 15px auto',
            width: '80%',
            maxWidth: 270
          }} 
        />
        <Box style={{
          // position: 'relative',
          // marginTop: -300,
          // zIndex: 9999
        }}>
          <p style={{
            textAlign: 'center',
            fontSize: isSmallScreen ? '14px' : '20px',
            lineHeight: isSmallScreen ? '20px' : '28px',
            maxWidth: 600,
            margin: isSmallScreen ? '20px auto' : '40px auto',
            padding: '0 10px'
          }}>
            Something exciting is on the way! Collect your digital medallion and stay tuned for more fun to come.
          </p>
          {userProfile.userId ? (
            <>
               {/* <button className='redeem-btn button-glow' onClick={() => navigate(ROUTES.CLAIM_CARD)}
                disalbed={!devHubUser?.address || devHubUser?.address.length <= 0}>
                  {devHubUser?.address && devHubUser?.address.length > 0 ? "Redeem Now" : <CircularProgress size={25} style={{ color: '#000000' }}  sx={{ color: '#000000' }} />}
               </button> */}
               <button className='redeem-btn button-glow' onClick={() => navigate(ROUTES.CLAIM_CARD)}>
                  Redeem Now
               </button>
            </>
          ) : (
            <button className='redeem-btn' onClick={handleOAuthLogin} disabled={isLoading}>
              {isLoading ? <CircularProgress size={25} style={{ color: '#000000' }}  sx={{ color: '#000000' }} /> : "Sign-In To Redeem"}
            </button>
          )}
          {/* <button className='learn-btn'>Learn more</button> */}
        </Box>
        <FAQ ref={targetRef} />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;
